export type TRole = 'admin' | 'seller';
export type TRoleId = 1 | 2;
export const ROLE_ID: { [key in TRoleId]: TRole } = {
  1: 'admin',
  2: 'seller'
};
export const ROLES = [
  { name: 'Admin', id: 1 },
  { name: 'Vendedor', id: 2 }
];
